
import { GiftIcon, BanknotesIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const TarjetasAdmin = ({ titulo = '', subtitulo1 = '', subtitulo2 = '', subtitulo3 = '', valor = 0, icono = 0, setIsColInfo, color1 = 'secundarioMira', color2 = 'secundario', colortexto1 = 'white',
    colortexto2 = 'grisMira', subtituloR = true }) => {

    let colortexto3 = ((subtituloR) ? 'secundario' : colortexto2)

    let valTarjeta = Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(valor)
    return (
        <dl className="pt-2 gap-5 flex flex-row flex-wrap">
            <div className={classNames('bg-' + color1, 'relative grow overflow-hidden rounded-lg px-4 pt-5 pb-2 shadow sm:px-6 sm:pt-6 hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2')}
            >
                <dt>
                    <h2 className={classNames('text-2xl font-semibold', 'text-' + colortexto1)}>{titulo}</h2>
                    <p className={classNames('truncate mb-1 text-sm font-medium', 'text-' + colortexto2)}> {subtitulo1 !== '' ? subtitulo1 : ''}</p>
                    <p className={classNames('truncate mb-1 text-sm font-medium', 'text-' + colortexto2)}> {subtitulo2 !== '' ? subtitulo2 : ''}</p>
                    <p className={classNames('truncate mb-1 text-sm font-medium', 'text-' + colortexto3)}> {subtitulo3 !== '' ? subtitulo3 : ''}</p>
                    {icono === 1 ?
                        (<div className={classNames('bg-' + color2, 'absolute rounded-md p-3')}>
                            <GiftIcon className="h-6 w-6 text-white" aria-hidden="true" />
                        </div>)
                        : icono === 2 ?
                            (<div className={classNames('bg-' + color2, 'absolute rounded-md p-3')}>
                                <button
                                    type="button"
                                    onClick={() => setIsColInfo(true)}
                                >
                                    <span className="sr-only">Open Cuotas</span>
                                    <BanknotesIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                </button>
                            </div>) : null
                    }
                </dt>
                <dd className="ml-14 flex items-baseline flex-wrap pb-6 sm:pb-7">
                    <p className={classNames('text-2xl font-semibold', 'text-' + colortexto2)}>
                        {(icono === 2 && valor > 0) ? (
                            <><button
                                type="button"
                                onClick={() => setIsColInfo(true)}
                            >
                                <span className="sr-only">Open Cuotas</span>
                                {valTarjeta}
                            </button>
                                <button
                                    type="button"
                                    onClick={() => setIsColInfo(true)}
                                >
                                    <span className="sr-only">Open Cuotas</span>
                                    <p className={classNames('truncate mb-1 text-sm font-medium', 'text-' + colortexto3)}>
                                        ¿Que es modalidad
                                        <br></br>
                                        variable?
                                    </p>
                                    <dl className="flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                                        <span className='text-sm font-semibold px-2 text-left text-white sm:pl-3 hover:text-azulBrillanteMira'>Ver más</span>
                                    </dl>
                                </button>
                            </>) : valor > 0 ? (valTarjeta) : null
                        }
                    </p>
                </dd>
            </div>
        </dl>
    )
}

export default TarjetasAdmin